import { useQuery } from "@apollo/client";
import { GET_BRAND_SEO } from "./queries";

export const useGetBrandSEO = (slug) => {
  const { data, loading } = useQuery(GET_BRAND_SEO, { variables: { slug } });

  return {
    loading,
    data
  };
};
